import React, { useEffect, useState } from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';
import MapView from 'react-native-maps';
import * as Location from 'expo-location';

import findNearestStation from '../../../utils/findNearestStation';
import findNearestSoil from '../../../utils/findNearestSoil';

import blueMarkerIcon from './map-assets/blue-dot.png';
import redMarkerIcon from './map-assets/red-dot.png';
import yellowMarkerIcon from './map-assets/yellow-dot.png';

const { width, height } = Dimensions.get('window');

export default function LocationSelectionMap({
  stations,
  updateSelectedSoil,
  updateSelectedStation,
  updateUserCoords,
  userCoords,
}) {
  const [selectedStation, setSelectedStation] = useState('');

  useEffect(() => {
    (async () => {
      try {
        let { status } = await Location.requestForegroundPermissionsAsync();

        if (status !== 'granted') {
          console.log('Permission to access location was denied');
          updateStationAndSoil({ coords: userCoords });
        } else {
          try {
            let location = await Location.getCurrentPositionAsync({
              accuracy: 3,
            });
            if (location) {
              updateUserCoords(location.coords);
              updateStationAndSoil(location);
            }
          } catch (err) {
            console.log(err);
            updateStationAndSoil({ coords: userCoords });
          }
        }
      } catch (err) {
        console.log(err);
        updateStationAndSoil({ coords: userCoords });
      }
    })();
  }, []);

  function updateStationAndSoil(location) {
    // find weather station closest to client or field marker location
    const nearestStation = findNearestStation(location.coords, stations);
    const station = nearestStation ? nearestStation : stations[0].key;

    updateFormAndMap(station);
    updateSoil(location, station);
  }

  function updateSoil(location, station) {
    // find soil code closest to client or field marker location
    const nearestSoil = findNearestSoil(location.coords, station);
    const soil = nearestSoil ? nearestSoil : 112;
    // update soil in form
    updateSelectedSoil(soil);
  }

  function updateFormAndMap(station) {
    // update selected station in form
    updateSelectedStation(station);
    // update selected station on map
    setSelectedStation(station);
  }

  function getPinIcon(key) {
    return key === selectedStation ? yellowMarkerIcon : redMarkerIcon;
  }

  function onPress(key) {
    if (key !== selectedStation) {
      updateFormAndMap(key);
      updateSoil({ coords: userCoords }, key);
    }
  }

  function isActive(key) {
    return key === selectedStation ? `${key}-active` : `${key}-inactive`;
  }

  return (
    <View style={styles.container}>
      <MapView
        initialRegion={{
          latitude: stations[0].coordinate.latitude + 0.5,
          longitude: stations[0].coordinate.longitude - 0.5,
          latitudeDelta: 1.5,
          longitudeDelta: 4.0 * (width / height),
        }}
        mapType="hybrid"
        showsUserLocation={true}
        style={styles.mapStyle}
      >
        <MapView.Marker
          coordinate={userCoords}
          draggable
          title="Field location (draggable)"
          icon={blueMarkerIcon}
          onDragEnd={(e) => {
            updateStationAndSoil({
              coords: { latitude: e.latLng.lat(), longitude: e.latLng.lng() },
            });
            updateUserCoords({
              latitude: e.latLng.lat(),
              longitude: e.latLng.lng(),
            });
          }}
        />
        {stations.map((station) => (
          <MapView.Marker
            key={isActive(station.key)}
            coordinate={station.coordinate}
            icon={getPinIcon(station.key)}
            onPress={() => onPress(station.key)}
          />
        ))}
      </MapView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mapStyle: {
    width: '100%',
    height: '100%',
  },
});
